export default __webpack_public_path__ + "static/media/tottenham.770d64c6.jpg";